'use client';

import { useEffect, useRef } from 'react';
import { captureProductTelemetry } from '@/lib/product-telemetry';

type TelemetryValue = string | number | boolean | null | undefined;

export function useProductTelemetryOnce(
  eventName: string,
  enabled: boolean,
  properties: Record<string, TelemetryValue>,
  dedupeKey?: string,
) {
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const key = dedupeKey ?? eventName;
    if (lastKeyRef.current === key) return;

    lastKeyRef.current = key;
    captureProductTelemetry(eventName, properties);
  }, [dedupeKey, enabled, eventName, properties]);
}
